import { Link, useMatch } from "react-router-dom";

import {
  RobotoDivider,
  RobotoStyledTab,
  RobotoStyledTabs,
} from "@/shared/components";
import { Goto } from "@/shared/navigation";

import styles from "./AgentDetailTabBar.module.css";

interface AgentDetailTabBarProps {
  /** Id of the agent whose detail pages the tabs link between. Tab
   *  links are built absolute from this id because the two mounting
   *  routes resolve relative paths differently. */
  agentId: string;
}

/**
 * Tab strip shared by the agent-detail pages: Details (the editor at
 * `/agents/:agentId`) and Threads (`/agents/:agentId/threads`).
 *
 * Derives the active tab from the URL via `useMatch`, so it carries no
 * state of its own and both pages can mount it unconditionally —
 * including in their loading and error branches, where stable chrome
 * lets the user tab away from a failed load.
 */
export function AgentDetailTabBar({ agentId }: AgentDetailTabBarProps) {
  const activeTab = useMatch("/agents/:agentId/threads")
    ? "threads"
    : "details";

  return (
    <div className={styles.tabBar}>
      <RobotoStyledTabs value={activeTab} aria-label="agent detail tabs">
        <RobotoStyledTab
          value="details"
          label="Details"
          component={Link}
          to={Goto.createAgentRoute(agentId)}
          replace
        />
        <RobotoStyledTab
          value="threads"
          label="Threads"
          component={Link}
          to={Goto.createAgentThreadsRoute(agentId)}
          replace
        />
      </RobotoStyledTabs>
      <RobotoDivider />
    </div>
  );
}
